export default {
  tags: {
    preferred: 'Preferowany',
  },
};
